<i18n src="@/locales/modules/RequestTypeTranslate.json"></i18n>

<template>
	<el-dialog append-to-body class="custom-nested-dialog request-type-dialog" :title="formTitle" :before-close="handleBeforeCloseDialog" :visible.sync="isDialogActiveLocal">
		<PerfectScrollbar>
			<form @submit.prevent="" autocomplete="off" class="form request-type-dialog__form p-6">
				<div class="mb-5">
					<legend class>{{ $t("Name") }}<span class="text-danger">&nbsp;*</span>:</legend>
					<cbs-input
						name="name"
						class="inputx w-full"
						:placeholder="`${$t('Actions.Input')} ${$t('Name').toLowerCase()}`"
						v-model="value.name"
						:data-vv-as="$t('Name')"
						v-validate="'required'"
					/>
					<span class="text-danger text-sm">{{ errors.first("name") }}</span>
				</div>

				<div class="mb-5">
					<legend class>{{ $t("Type") }}<span class="text-danger">&nbsp;*</span>:</legend>
					<v-select
						name="type"
						label="name"
						v-validate="'required'"
						v-model="value.typeId"
						:options="listTypes"
						:reduce="type => type.id"
						:data-vv-as="$t('Type')"
						:placeholder="`${$t('Actions.Choose')} ${$t('Type').toLowerCase()}`"
					>
						<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
					</v-select>
					<span class="text-danger text-sm">{{ errors.first("type") }}</span>
				</div>

				<div class="mb-5">
					<legend class>{{ $t("SetRequestCode") }}:</legend>
					<cbs-input
						name="setrequestcode"
						class="inputx w-full"
						:placeholder="`${$t('SetRequestCodePlaceholder')}`"
						v-model="value.generate_code"
						:data-vv-as="$t('SetRequestCode')"
						v-validate="{ regex: /^\(?(#{6})\)?.{1,10}?$/ }"
					/>
					<p>{{ $t("RequestCodeDescription") }}</p>
					<span class="text-danger text-sm">{{ errors.first("setrequestcode") }}</span>

					<div class="mt-5">
						<label for class="text-base vs-input--label">{{ $t("Repeat") }}:</label>
						<div class="grid gap-4 grid-cols-3">
							<vs-radio v-model="value.schedule_generate_code" vs-name="schedule_generate_code" :data-vv-as="$t('Repeat')" v-validate="'required'" :vs-value="1">
								Liên tục
							</vs-radio>
							<vs-radio v-model="value.schedule_generate_code" vs-name="schedule_generate_code" :data-vv-as="$t('Repeat')" v-validate="'required'" :vs-value="2">
								Tạo lại theo tháng
							</vs-radio>
							<vs-radio v-model="value.schedule_generate_code" vs-name="schedule_generate_code" :data-vv-as="$t('Repeat')" v-validate="'required'" :vs-value="3">
								Tạo lại theo năm
							</vs-radio>
						</div>
					</div>
				</div>

				<div class="mb-5">
					<legend class>{{ $t("PeopleAllowedToCreateRequest") }}:</legend>
					<cbs-relations-humanroles
						:close-on-select="false"
						:data-vv-as="$t('PeopleAllowedToCreateRequest')"
						:placeholder="`${$t('Actions.Choose')} ${$t('PeopleAllowedToCreateRequest').toLowerCase()}`"
						v-model="value.allowedPeople"
						:type="2"
						:for="'people'"
					/>

					<div class="mt-3" v-html="$t('AllowedPeopleNote')"></div>
				</div>

				<div :class="{ 'mb-4': isEditForm }">
					<legend class>{{ $t("Template") }}:</legend>
					<span class="text-sm">*{{ $t("TemplateFileValidation") }}</span>
					<cbs-upload-ref
						v-model="localAttachFile"
						accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
						:limit="1"
						:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
					/>
				</div>

				<div class="grid gap-4 grid-cols-3 mt-3">
					<div class="flex items-center leading-full" v-if="isEditForm" >
						<vs-switch color="success" v-model="value.isDisabled"/>
						<span class="ml-3" >{{ $t("IsDisabled") }}</span>
					</div>
					<div class="flex items-center leading-full">
						<vs-switch color="success" v-model="value.isPrivate" />
						<span class="ml-3">{{ $t("isPrivate") }}</span>
					</div>
				</div>
			</form>
		</PerfectScrollbar>
		<div slot="footer" class="flex items-center sm:px-12 justify-center">
			<vs-button @click.stop="submitData" class="w-full sm:w-2/5 font-bold">{{ $t("Actions.Save") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";

import vSelect from "vue-select";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";

export default {
	name: "RequestTypeDialog",
	components: { vSelect, CbsUploadRef },
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => {
				const isValidProp = _.has(prop, "id") && _.has(prop, "name") && _.has(prop, "typeId") && _.has(prop, "attachFile") && _.has(prop, "allowedPeople") && _.has(prop, "generate_code");
				if (!prop.id) {
					return isValidProp;
				}
				return isValidProp && _.has(prop, "isDisabled");
			}
		},
		isDialogActive: {
			type: Boolean,
			required: true
		}
	},
	emits: {
		closeDialog: {
			required: true
		},
		onSubmit: {
			required: true
		}
	},
	data() {
		return {
			initFormData: {},
			isFormDirty: false
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		},
		listTypes() {
			return [
				{ id: this.$constant.REQUEST_TYPE_DEVICE, name: this.$t("DeviceRequest") },
				{ id: this.$constant.REQUEST_TYPE_GENERAL, name: this.$t("GeneralRequest") }
			];
		},
		isEditForm() {
			return !!this.value.id;
		},
		formTitle() {
			return this.isEditForm ? this.$t("UpdateRequestType") : this.$t("CreateRequestType");
		},
		localAttachFile: {
			get() {
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		}
	},
	watch: {
		isDialogActive(val) {
			if (!val) return;

			if (!this.value) {
				this.initValues();
			}
		},
		value: {
			handler: function() {
				this.isFormDirty = JSON.stringify(this.value) !== JSON.stringify(this.initFormData);
			},
			deep: true
		}
	},
	methods: {
		initValues() {
			this.isFormDirty = false;
		},
		submitData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$emit("onSubmit");
				}
			});
		},
		handleBeforeCloseDialog(setDialogHide) {
			this.handleCloseDialog(() => {
				this.initValues();
				setDialogHide();
			}, this.isFormDirty);
		},
		handleChangeFile(uploadedFiles) {
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		}
	},
	created() {
		this.initFormData = Object.assign({}, this.value);
	}
};
</script>
